import { Alert, Card, Screen, Stack } from '../components';
import { configProblems } from '../lib/env';

/**
 * Shown instead of the app when .env.local hasn't been filled in. Without this
 * the first run is a white screen and a console error, which tells you nothing.
 */
export function SetupRequiredPage() {
  return (
    <Screen center maxWidth={560}>
      <Stack gap={5}>
        <div>
          <h1 style={{ fontSize: 'var(--fs-display)', letterSpacing: '-0.02em' }}>Tabi</h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: 'var(--sp-2)' }}>
            The app is running. It just isn't connected to a Supabase project yet.
          </p>
        </div>

        <Alert tone="warning" title="Supabase not configured">
          <ul style={{ margin: 'var(--sp-2) 0 0', paddingLeft: 'var(--sp-5)' }}>
            {configProblems.map((problem) => (
              <li key={problem} style={{ marginBottom: 'var(--sp-1)' }}>
                {problem}
              </li>
            ))}
          </ul>
        </Alert>

        <Card>
          <Stack gap={3}>
            <h2>What to do</h2>
            <ol
              style={{
                margin: 0,
                paddingLeft: 'var(--sp-5)',
                color: 'var(--text-secondary)',
                fontSize: 'var(--fs-body-md)',
                lineHeight: 1.7,
              }}
            >
              <li>
                Follow <code>SETUP.md</code> in the repo root — it walks through creating the
                Supabase project and running the schema.
              </li>
              <li>
                Copy <code>.env.example</code> to <code>.env.local</code> and paste in your Project
                URL and anon key.
              </li>
              <li>
                Restart the dev server. Vite only reads <code>.env.local</code> at startup, so
                editing it while the server runs changes nothing.
              </li>
            </ol>
            <p style={{ fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)' }}>
              Everything you can see right now is rendered from local design tokens — no network
              calls are being made.
            </p>
          </Stack>
        </Card>
      </Stack>
    </Screen>
  );
}
